export const iconsNameList = {
  appetite: 'appetite',
  add_a_note: 'addANote',
  body_mass: 'bodyMass',
  breath: 'breath',
  comment: 'comment',
  calendar: 'calendar',
  detector: 'detector',
  bold_plus: 'boldPlus',
  slim_plus: 'slimPlus',
  pulse: 'pulse',
  save: 'save',
  man_self_training: 'ManSelfTraining',
  shared: 'shared',
  sleep: 'sleep',
  verified_card: 'verifiedCard',
  man_running: 'manRunning',
  heart_health: 'heartHealth',
  remove_cross: 'removeCross',
  square: 'square',
  duration: 'duration',
  reward: 'reward',
  manExercise: 'manExercise',
  findInBook: 'findInBook',
  openBook: 'openBook',
  glasses: 'glasses',
  search: 'search',
  arrowLeft: 'arrowLeft',
  strips: 'strips',
  key: 'key',
  profile: 'profile',
  consultation: 'consultation',
  logo: 'logo',
  close: 'close',
  clock: 'clock',
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppSvgIcon/iconsList.ts